module.exports = __webpack_public_path__ + "img/Weapon_08.78e7d1e4.png";